var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FormAddInsuranceAFY, ModalAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var AddInsuranceModalResources = function (props) {
    return (_jsx(ModalAFY, __assign({ title: "Ingresar asegurado", name: "", openModal: props.openModalAddInsurance, onClose: function () {
            props.setOpenModalAddInsurance(false);
        }, minWidthModal: "960px", heightModal: "745px", backgroundColor: "#FFFFFF", closeModalOutside: true }, { children: _jsx(FormAddInsuranceAFY, { section1Title: "Datos generales del Asegurado", section2Title: "Ubicaci\u00F3n", section3Title: "Contacto", isMaskedDocument: props.isMaskedDocument, hideMarriedName: props.hideMarriedName, dataForm: props.dataFormInsuranceSp, onChangeSelect: props.handleChangeSelectFormInsurance, CountryList: props.CountryList || [], ProvinceList: props.ProvinceList || [], TownList: props.TownList || [], SectorList: props.SectorList || [], GenderList: props.GenderList || [], TypeList: props.identificationList || [], typeInsuredOption: props.insuredType || [], onNext: function (data) {
                props.handleSubmitInsured(data);
            }, onClickCancel: function () {
                props.setOpenModalAddInsurance(false);
            } }) })));
};
